import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './translation_en.json';
import fr from './translation_fr.json';
import ca from './translation_ca.json';

const resources = {
  en_US: {
    translation: en
  },
  fr_CA: {
    translation: fr
  },
  en_CA:{
    translation: ca
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng:'en_US',
    fallbackLng: 'en_US',
    debug: false,
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;